(function () {
	//
	// Variables
	//
	let productInfo;
	let productHandle = Array.from(document.getElementsByClassName('shopify-product-form'));
	console.log(productHandle);

	let productSizeOptions;
	let increaseButton = Array.from(document.getElementsByClassName('quantity-increase'));
	let decreaseButton = Array.from(document.getElementsByClassName('quantity-decrease'));
	let quantityValues = Array.from(document.getElementsByClassName('quantity-value'));
	let productTypeButtons = Array.from(document.querySelectorAll('[data-option-name="type"]'));
	let productSizeButtons = Array.from(document.querySelectorAll('[data-option-name="size"]'));
	let productSizeInputs = Array.from(document.querySelectorAll('input[name="size"]'));
	let addToCartButtons = Array.from(document.getElementsByClassName('add-to-cart'));
	let rechargeButtons = Array.from(document.getElementsByClassName('recharge-button'));
	let chosenType = '';
	let chosenSize = '';
	let items;
	let addToCartQuantity;

	// let rechargeWidgetOneTime;
	// let subscriptionOptions;

	//
	// Initial Actions
	//

	// Initial fetch of product information to use for variant picker
	async function fetchProduct() {
		const response = await fetch(
			window.Shopify.routes.root + `products/${productHandle[0].getAttribute('data-name')}.js`
		);
		const result = await response.json(); // Wait for the JSON parsing to complete
		productInfo = result; // result is now the actual parsed JSON object
		productSizeOptions = Array.from(productSizeButtons.map((size) => size.getAttribute('for')));
		console.log(productInfo);
	}
	fetchProduct();

	//
	// Utilities
	//

	// increases quantity value
	const increaseQuantityValueHandler = (id) => {
		quantityValues.forEach((quantity) => {
			if (quantity.id == `${id}-quantity`) {
				quantity.value = parseInt(quantity.value) + 1;
			}
		});
	};

	// decreases quantity value
	const decreaseQuantityValueHandler = (id) => {
		quantityValues.forEach((quantity) => {
			if (quantity.id == `${id}-quantity`) {
				if (quantity.value > 1) {
					quantity.value = parseInt(quantity.value) - 1;
				}
			}
		});
	};

	// Primary funtion to check if a specific type/size is available
	const variantAvailabilityCheckHandler = (type) => {
		// removes unavailable class from all buttons fist
		productSizeButtons.forEach((element) => {
			if (element.classList.contains('unavailable')) {
				element.classList.toggle('unavailable');
			}
		});
		let typeArray = [];
		productInfo.variants.forEach((variant) => {
			if (variant.name.includes(type) & (variant.available == true)) {
				typeArray.push(variant.option2);
			}
		});
		let unavialableSizes = productSizeOptions.filter((size) => !typeArray.includes(size));
		unavialableSizes.forEach((size) => {
			document.querySelector(`label[data-option-name="size"][for="${size}"]`).classList.toggle('unavailable');
		});
	};

	const typeButtonClickHandler = (type) => {
		chosenType = type;
		chosenSize = '';
		variantAvailabilityCheckHandler(type);

		productSizeInputs.forEach((input) => {
			input.checked = false;
		});

		console.log(chosenType + '   ' + chosenSize);
		if (chosenType !== '' || chosenSize !== '') {
			addToCartButtons.forEach((button) => {
				if (!button.classList.contains('disabled')) {
					button.classList.toggle('disabled');
					button.setAttribute('disabled', '');
				}
			});
		}
	};

	const sizeButtonClickHandler = (size) => {
		chosenSize = size;
		if (chosenType !== '' && chosenSize !== '') {
			addToCartButtons.forEach((button) => {
				if (button.classList.contains('disabled')) {
					button.classList.toggle('disabled');
					button.removeAttribute('disabled');
				}
			});
		}
	};

	// Send To Cart
	const sendToCart = () => {
		setTimeout(() => {
			window.location.href = '/cart';
		}, 1500);
	};

	let errorHandler = (error, formData) => {
		console.log('Error formData - ', formData);
		alert('Error - ', error);
	};

	// Add To Cart
	const addToCartHandler = (classList) => {
		event.preventDefault();
		if (classList.includes('disabled')) {
			return;
		}

		let addToCartId = `${productHandle[0].getAttribute('data-name')}-quantity`.replaceAll(' ', '-');
		console.log(addToCartId);
		if (document.getElementById(addToCartId)) {
			addToCartQuantity = parseInt(document.getElementById(addToCartId).value);
		}

		let chosenVariant = productInfo.variants.filter((variant) => variant.title == `${chosenType} / ${chosenSize}`);

		if (document.getElementById('date') !== null) {
			let giftCard = document.querySelector('input.demos:checked');
			items = { id: giftCard.dataset.variant, quantity: 1 };
		} else {
			items = { id: chosenVariant[0].id, quantity: addToCartQuantity };
		}

		// console.log(items);
		if (document.getElementById('recharge-manual-wrap') !== null) {
			let subscriptionType = document.querySelector('input[name="frequency"]:checked').value;
			let sellingPlanId = document.getElementById('deliver-select').value;
			if (subscriptionType != 'one-time') {
				// console.log(sellingPlanId);
				items['selling_plan'] = sellingPlanId;
			}
			// console.log(items);
			// console.log(chosenSize, chosenType);
		}
		if (document.getElementById('gift-checkbox') && document.getElementById('gift-checkbox').checked) {
			let recipientName = document.getElementById('recipient-name').value;
			let recipientEmail = document.getElementById('recipient-email').value;
			let giftMessage = document.getElementById('optional-message').value;

			let deliveryDate = document.getElementById('date').value;
			let formattedDate = '';

			if (deliveryDate) {
				// User picked a date
				const parsedDate = new Date(deliveryDate);
				if (!isNaN(parsedDate)) {
					formattedDate = parsedDate.toISOString().split('T')[0]; // 'YYYY-MM-DD'
				}
			} else {
				// No date selected — use today's date
				const today = new Date();
				formattedDate = today.toISOString().split('T')[0]; // 'YYYY-MM-DD'
			}

			items['properties'] = {
				__shopify_send_gift_card_to_recipient: 'true',
				'Recipient email': recipientEmail,
				'Recipient name': recipientName,
				Message: giftMessage,
				'Send on': formattedDate,
			};
		}

		let button = document.querySelector('.add-to-cart');
		button.setAttribute('value', 'Adding...');
		button.classList.add('disabled');

		let formData = {
			items: [items],
		};
		console.log(JSON.stringify(formData));
		// console.log(formData);
		fetch(window.Shopify.routes.root + 'cart/add.js', {
			method: 'POST',
			headers: {
				'Content-Type': 'application/json',
				'X-Requested-With': 'XMLHttpRequest',
			},
			body: JSON.stringify(formData),
		})
			.then((response) => {
				if (!response.ok) {
					throw new Error('Add to cart failed with status ' + response.status);
				}
				return response.json();
			})
			.then((data) => {
				console.log('Add to cart response:', data); // <-- LOG HERE
				updateCartHandler(); // your cart drawer or mini-cart update
			})
			.catch((error) => {
				console.error('Error adding to cart:', error);
				console.log('Payload sent:', formData); // Optional: debug what was sent
			});
		// .catch((error) => {
		// 	errorHandler(error, formData);
		// })
		// .then(sendToCart());
	};

	// Recharge Subscription Buttons
	const rechargeButtonClickHandler = (button) => {
		let subscriptionType = document.querySelector('input[name="frequency"]:checked').value;
		let subSaveDetail = document.getElementById('sub-save');

		console.log(button);

		rechargeButtons.forEach((buttons) => {
			if (buttons.classList.contains('active')) {
				buttons.classList.remove('active');
			}
		});
		button.classList.toggle('active');

		//hide and show sub details and frequncy drop down
		if (subscriptionType == 'sub-and-save') {
			subSaveDetail.classList.add('active');
		} else {
			subSaveDetail.classList.remove('active');
		}
	};

	//
	// Event Listeners
	//

	// add event listner to all increase quantity buttons

	let test = () => {
		console.log('test');
		let increaseButton = Array.from(document.getElementsByClassName('quantity-increase'));
		increaseButton.forEach((button) => {
			button.addEventListener('click', () => {
				increaseQuantityValueHandler(button.getAttribute('data-product'));
			});
		});
	};
	test();
	// add event listner to all decrease quantitiy buttons
	decreaseButton.forEach((button) => {
		button.addEventListener('click', () => {
			decreaseQuantityValueHandler(button.getAttribute('data-product'));
		});
	});

	// add event lister to all Type variant buttons (Men's, Women's Youth)
	productTypeButtons.forEach((button) => {
		button.addEventListener('click', () => {
			typeButtonClickHandler(button.innerHTML);
		});
	});

	productSizeButtons.forEach((button) => {
		button.addEventListener('click', () => {
			sizeButtonClickHandler(button.innerHTML);
		});
	});

	// add event listener to all Add To Cart Buttons
	addToCartButtons.forEach((button) => {
		button.addEventListener('click', () => {
			addToCartHandler(button.classList.value);
		});
	});

	// add event listener to Recharge Buttons
	rechargeButtons.forEach((button) => {
		button.addEventListener('click', () => {
			rechargeButtonClickHandler(button);
		});
	});
})();
